import React from "react";
import "../../styles/Realisations.css"; // on réutilise la même feuille

const CATEGORY_LABELS = {
  CONSEIL_FORMATION: "CONSEIL ET FORMATION",
  PREPA_GRANDE_CROISIERE: "PRÉPARATION GRANDE CROISIÈRE",
  COQUE_PONT: "PRÉPARATION COQUE & PONT",
  METALLERIE: "TRAVAUX DE MÉTALLERIE",
  GREEMENT_VOILES: "GRÉEMENT & VOILES",
  NETTOYAGE_CONCIERGERIE: "NETTOYAGE & CONCIERGERIE",
};

function formatCategories(item) {
  const cats = Array.isArray(item?.categories) ? item.categories : [];

  // compat ancien champ
  if (cats.length === 0 && item?.category) {
    const one = String(item.category).trim();
    if (one) return CATEGORY_LABELS[one] || one;
  }

  if (cats.length === 0) return "AUTRE";

  const first = CATEGORY_LABELS[cats[0]] || cats[0];
  if (cats.length === 1) return first;
  return `${first} + ${cats.length - 1}`;
}

export default function RealisationCard({
  item,
  onClick,
  isAdmin,
  onEdit,
  onDelete,
  disabled,
}) {
  const badge = formatCategories(item);

  // ✅ image: nouveau champ coverImage.url (avec fallback)
  const imgSrc = item?.coverImage?.url || item?.cover || "";
  const imgAlt = item?.coverImage?.alt || item?.title || "";

  return (
    <article className="real-card" onClick={() => onClick?.(item)}>
      <div className="real-card__media">
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={imgAlt}
            loading="lazy"
            decoding="async"
            sizes="(max-width: 600px) 100vw, (max-width: 1024px) 50vw, 33vw"
          />
        ) : (
          <div className="real-card__mediaPlaceholder">Sans image</div>
        )}

        <span className="real-card__badge">{badge}</span>
      </div>

      <div className="real-card__body">
        <h3 className="real-card__title">{item.title}</h3>
        <p className="real-card__desc">{item.description}</p>

        <div className="real-card__meta">
          <span>{item.year}</span>

          <div className="real-card__tags">
            {(item.tags || []).map((t, idx) => (
              <span key={`${t}-${idx}`} className="real-card__tag">
                #{t}
              </span>
            ))}
          </div>
        </div>
      </div>

      {isAdmin && (
        <div className="real-card__admin">
          <button
            type="button"
            className="real-btn real-btnSmall"
            onClick={(e) => {
              e.stopPropagation();
              onEdit?.(item);
            }}
            disabled={disabled}
          >
            Modifier
          </button>
          <button
            type="button"
            className="real-btn real-btnSmall"
            onClick={(e) => {
              e.stopPropagation();
              onDelete?.(item);
            }}
            disabled={disabled}
          >
            Supprimer
          </button>
        </div>
      )}
    </article>
  );
}
